const DV1_WEIGHTS = [10, 9, 8, 7, 6, 5, 4, 3, 2];
const DV2_WEIGHTS = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];

export function cleanCpf(value?: string | null): string {
  return value?.replace(/\D/g, "") ?? "";
}

function calculateCheckDigit(digits: string, weights: number[]): number {
  const sum = weights.reduce(
    (accumulator, weight, index) => accumulator + Number(digits[index]) * weight,
    0
  );
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

export function isValidCpf(value?: string | null): boolean {
  const document = cleanCpf(value);
  if (document.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(document)) return false;
  const firstCheckDigit = calculateCheckDigit(document.slice(0, 9), DV1_WEIGHTS);
  const secondCheckDigit = calculateCheckDigit(document.slice(0, 10), DV2_WEIGHTS);
  return (
    document[9] === String(firstCheckDigit) &&
    document[10] === String(secondCheckDigit)
  );
}
